// extracted by mini-css-extract-plugin
module.exports = {"downloadSection":"DownloadSection_downloadSection__3eDUQ","downloadOptions":"DownloadSection_downloadOptions__1SMRS","optionBtn":"DownloadSection_optionBtn__3cjG4"};